define("settings/components/modal-form", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <form {{on "submit" this.onSubmit}}>
    {{yield
      (hash
        input=(component "modal/form-input")
        footer=(component
          "modal/form-footer"
          isDisabled=(or @task.isRunning @isDisabled)
          isRunning=@task.isRunning
          runningText=@runningText
          cancel=@cancel
          cancelButtonQaClass=@cancelButtonQaClass
          submitButtonQaClass=@submitButtonQaClass
        )
      )
    }}
  </form>
  */
  {
    "id": "qOZqT7uk",
    "block": "[[[11,\"form\"],[4,[38,0],[\"submit\",[30,0,[\"onSubmit\"]]],null],[12],[1,\"\\n  \"],[18,7,[[28,[37,2],null,[[\"input\",\"footer\"],[[50,\"modal/form-input\",0,null,null],[50,\"modal/form-footer\",0,null,[[\"isDisabled\",\"isRunning\",\"runningText\",\"cancel\",\"cancelButtonQaClass\",\"submitButtonQaClass\"],[[28,[37,4],[[30,1,[\"isRunning\"]],[30,2]],null],[30,1,[\"isRunning\"]],[30,3],[30,4],[30,5],[30,6]]]]]]]]],[1,\"\\n\"],[13]],[\"@task\",\"@isDisabled\",\"@runningText\",\"@cancel\",\"@cancelButtonQaClass\",\"@submitButtonQaClass\",\"&default\"],false,[\"on\",\"yield\",\"hash\",\"component\",\"or\"]]",
    "moduleName": "settings/components/modal-form.hbs",
    "isStrictMode": false
  });
  let ModalFormComponent = _exports.default = (_class = class ModalFormComponent extends _component2.default {
    onSubmit(event) {
      event.preventDefault();
      if (this.args.isDisabled || this.args.task?.isRunning) {
        return;
      }
      this.args.task?.perform();
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "onSubmit", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmit"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ModalFormComponent);
});